import { EClientPath } from '~/models/api'

// eslint-disable-next-line import/prefer-default-export
export const guidanceSteps = [
  {
    id: 'train-assistant',
    title: 'Train your assistant',
    description:
      'Specify how your assistant should behave in every conversation.',
    details: '', // Just add here (for each object) the details you want to see in the expanded accordion
    link: EClientPath.settingsCoreBehavior,
  },
  {
    id: 'guide-assistant',
    title: 'Add detailed knowledge',
    description:
      'Train your assistant with detailed information about your business and your products or services.',
    details: '',
    link: EClientPath.settingsKnowledge,
  },
  {
    id: 'phone-number',
    title: 'Set up your phone number',
    description: 'Choose an area code, intro message, and more.',
    details: '',
    link: EClientPath.settingsPhone,
  },
  {
    id: 'live-transfers',
    title: 'Set up live transfers',
    description:
      'Set when you want to transfer callers to another phone number.',
    details: '',
    link: EClientPath.liveTransfersScenarios,
  },
  {
    id: 'chatbot',
    title: 'Set up your chatbot',
    description: 'Choose a logo, intro message, and more.',
    details: '',
    link: EClientPath.settingsChatbot,
  },
  {
    id: 'email',
    title: 'Set up your email',
    description: 'Choose your email, set a footer, and more.',
    details: '',
    link: EClientPath.settingsEmail,
  },
  {
    id: 'notifications',
    title: 'Set up notifications',
    description: 'Choose how you want to be notified for new interactions.',
    details: '',
    link: EClientPath.settingsNotifications,
  },
  {
    id: 'launch',
    title: 'Launch',
    description:
      'Add your chatbot, email, and phone number to your website, and/or forward calls to your AI assistant phone number.',
    details: '',
    link: '', // leave link property empty if no link
  },
]
